import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconSmartphone = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <rect width='14' height='20' x='5' y='2' rx='2' ry='2' />
      <path d='M12 18h.01' />
    </g>
  </SDIcon>
)

export default IconSmartphone
